export const propsButtonFlag = {
  src: "",
  type: "button",
  alt: "Translation Flag",
  title: "Translation",
  className: "flagImg",
};
